module.exports = __webpack_public_path__ + "media/01.b0a2b2f9.mp4";